import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'plateNumberFormat',
    pure: true,
    standalone: false
})
export class PlateNumberFormatPipe implements PipeTransform {
  transform(row: any, ...args: unknown[]): string {
    return row.mission?.plateNumber || '';
  }
}